import { Invoice, IPaginationInvoices } from '../models';
import { map, switchMap, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ApiService } from './api.service';
import { ApiV2AuthenticationService } from './api-v2-authentication.service';
import { Injectable } from '@angular/core';

@Injectable()
export class InvoiceService {

  constructor(private apiService: ApiService,
    private apiV2AuthService: ApiV2AuthenticationService
  ) { }


  findInvoice(params: any, invoiceType: string): Observable<IPaginationInvoices> {
    return this.apiV2AuthService.getApiV2Token().pipe(
      switchMap(token =>
        this.apiService.get(`/invoices/${invoiceType}/filter`, params, true, token)
      ),
      map((response: any) => response || {})
    )
  }

  listInvoice(invoiceType: string): Observable<Invoice[]> {
    return this.apiV2AuthService.getApiV2Token().pipe(
      switchMap(token =>
        this.apiService.get(`/invoices/${invoiceType}/list`, undefined, true, token)
      ),
      map((response: any) => response.invoices || [])
    )
  }

  /**
   * Télécharge le PDF d'une facture
   * @param invoiceNumber Numéro de la facture
   * @returns Observable du résultat du téléchargement
   */
  downloadInvoicePdf(invoiceNumber: string): Observable<{ success: boolean; error?: string }> {
    return this.apiV2AuthService.getApiV2Token().pipe(
      switchMap(token =>
        this.apiService.getBlob(
          `/invoices/${encodeURIComponent(invoiceNumber)}/download`,
          true,
          token
        )
      ),
      map((response: any) => {
        if (!response.body || response.status !== 200) {
          return {
            success: false,
            error: 'Erreur lors du téléchargement de la facture',
          };
        }

        // Télécharger le fichier
        const blob = response.body;
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        // Essayer d'extraire le nom du fichier depuis Content-Disposition
        let fileName = `${invoiceNumber}.pdf`;
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=(['"]?)([^'"\n]*?)\1(?:;|$)/i);
          if (filenameMatch && filenameMatch[2]) {
            fileName = filenameMatch[2];
          }
        }
        
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(downloadUrl);

        return { success: true };
      }),
      catchError(error => {
        console.error('Erreur téléchargement facture:', error);
        return of({
          success: false,
          error: error instanceof Error ? error.message : 'Erreur réseau',
        });
      })
    );
  }
}